<template>
  <div class="container-wrap">
    <div class="mwow-button-filled success" @click="addOrEmit('add', '')">
      添加假期
    </div>
    <div class="top-tips">
      门店员工、学员关注公众号并完成登录后可以正常接收消息推送
      <el-popover
        placement="top"
        width="250"
        popper-class="followuppopover"
        trigger="hover"
      >
        <p class="tipck">
          不推送的消息可在消息推送列表查看，包含：
          员工：上课提醒通知、课程结束提醒、考勤异常提醒、考勤异常通知；
          学员：上课提醒通知、学员考勤通知；
        </p>
        <div class="question" slot="reference">
          <div>?</div>
        </div>
      </el-popover>
    </div>
    <div>
      <el-table
        class="mwow-table"
        size="mini"
        :data="tableData"
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        @sort-change="handleSortChange"
        :default-sort="{
          order: 'descending',
          prop: 'create_time',
        }"
      >
        <el-table-column label="假期名称" prop="title"></el-table-column>
        <el-table-column label="开始时间" prop="start_time"></el-table-column>
        <el-table-column label="结束时间" prop="end_time"></el-table-column>
        <el-table-column label="停课班级">
          <template slot-scope="scope">
            <div v-if="scope.row.stop_type === 2">全部</div>
            <div v-if="scope.row.stop_type === 1">
              部分，已选择 {{ scope.row.class_num }} 个班
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark">
          <template slot-scope="scope">
            <div>{{ scope.row.remark || "-" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="create_time"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100">
          <template slot-scope="scope">
            <span class="cu-po" @click="addOrEmit('emit', scope.row)"
              >编辑</span
            >
            <span> &nbsp;|&nbsp; </span>
            <span class="cu-po" @click="del(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="pageSizeArray"
        :style="{ float: 'right', padding: '20px' }"
        :total="total"
        @current-change="handlePagerChange"
        @size-change="handlePagerSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <!-- 添加编辑学员 -->
    <el-drawer
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      direction="rtl"
      :size="473"
      :before-close="handleClose"
      destroy-on-close
      @open="openDialog"
    >
      <div>
        <p style="padding: 15px 20px 0 20px" class="mwow-yellow">
          注意: 假期添加成功后, 在假期内的班级课程不再支持点名;
        </p>
        <div>
          <el-form
            :model="dialogForm"
            :rules="rules"
            ref="ruleFormDom"
            label-width="75px"
            class="drawer-form"
            label-position="left"
            size="mini"
          >
            <el-form-item label="假期名称: " prop="vacationName">
              <el-input
                v-model="dialogForm.vacationName"
                placeholder="请输入"
                type="text"
              ></el-input>
            </el-form-item>
            <el-form-item label="开始时间：" prop="start_time">
              <el-date-picker
                v-model="dialogForm.start_time"
                value-format="timestamp"
                type="date"
                @change="handleChange"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间：" prop="end_time">
              <el-date-picker
                v-model="dialogForm.end_time"
                value-format="timestamp"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="停课班级：" prop="class_type">
              <div style="display: flex; align-items: center">
                <el-radio-group v-model="dialogForm.class_type">
                  <el-radio-button :label="2">全部</el-radio-button>
                  <el-radio-button :label="1">部分</el-radio-button>
                </el-radio-group>
                <el-popover
                  placement="top"
                  width="260"
                  popper-class="followuppopover"
                  trigger="hover"
                >
                  <p class="tipck">
                    全部：未来新建的班级也会被默认加入假期中；
                    部分：手动选择休假的班级课次，未选择的不参与休假；
                  </p>
                  <div class="question" slot="reference">
                    <div>?</div>
                  </div>
                </el-popover>
              </div>
            </el-form-item>
            <el-form-item prop="class_list" v-if="dialogForm.class_type === 1">
              <div class="mwow-common-form-multi-select">
                <div class="input-wrap">
                  <p class="text">
                    已选择<span class="mwow-green">{{
                      dialogForm.class_list.length
                    }}</span
                    >个班
                  </p>
                  <add-class-dialog
                    :origin-data="dialogForm.class_list"
                    @change="handleClassSelect"
                    :single="false"
                  >
                    <el-button class="mwow-button success">添加班级</el-button>
                  </add-class-dialog>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="备注: " prop="remake">
              <el-input
                v-model="dialogForm.remake"
                type="textarea"
                placeholder="请输入"
                :autosize="{ minRows: 4, maxRows: 8 }"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <div class="btns">
            <div class="mwow-button-filled mini" @click="handleClose">取消</div>
            <div class="mwow-button-filled mini success" @click="handleSubmit">
              确定
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import addClassDialog from "./addClassDialog.vue";
import {
  holidayAddApi,
  holidayAddEmitInter,
  holidayListApi,
  holidayDetailApi,
  holidayEditApi,
  holidayDelApi,
} from "@/api/holiday";
import { dateFormat } from "@/utils/timeFormat";

export default {
  components: {
    addClassDialog,
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "添加假期",
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      dialogForm: {
        vacationName: "",
        class_type: 2,
        class_list: [],
        remake: "",
        class_ids: [],
        sort_field: "create_time",
        sort_type: "desc",
        start_time: "",
        end_time: "",
      },
      tableData: [],
      rules: {
        vacationName: [
          { required: true, message: "请输入假期名称", trigger: "change" },
        ],
        start_time: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        end_time: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
        class_type: [
          { required: true, message: "请选择停课班级", trigger: "change" },
        ],
        class_list: [
          { required: true, message: "请选择停课班级", trigger: "change" },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.dialogForm.start_time) {
            return (
              time.getTime() < new Date(this.dialogForm.start_time).getTime()
            );
          }
        },
      },
    };
  },

  created() {
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  },
  methods: {
    handleClassSelect(arr) {
      this.dialogForm.class_list = arr;
      const ids = arr.map((item) => {
        return item.class_id;
      });
      this.dialogForm.class_ids = ids;
    },
    handleChange(val) {
      this.dialogForm.start_time = val;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    openDialog() {
      if (this.dialogTitle === "添加假期") {
        this.dialogForm.vacationName = "";
        this.dialogForm.class_type = 2;
        this.dialogForm.class_list = [];
        this.dialogForm.remake = "";
        this.dialogForm.start_time = "";
        this.dialogForm.end_time = "";
      }
    },
    del(val) {
      this.$confirm(
        "删除后，原假期时间内的班级课次将不再停课，非假期课次恢复点名功能。确定要删除假期？",
        `删除假期 - ${val.title}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          holidayDelApi({
            holiday_id: val.holiday_id,
          }).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList({
                page: this.page,
                page_size: this.pageSize,
              });
            }
          });
        })
        .catch(() => {});
    },
    handleSubmit() {
      this.$refs["ruleFormDom"].validate((valid) => {
        if (valid) {
          const data = {
            title: this.dialogForm.vacationName,
            start_time: this.dialogForm.start_time / 1000,
            end_time: this.dialogForm.end_time / 1000 + 86399, // 当前日期的 23:59:59
            stop_type: this.dialogForm.class_type,
          };
          if (this.dialogForm.remake) {
            data.remark = this.dialogForm.remake;
          }
          if (this.dialogTitle === "添加假期") {
            if (
              this.dialogForm.class_ids?.length > 0 &&
              this.dialogForm.class_type === 1
            ) {
              data.class_ids = this.dialogForm.class_ids;
            }
            holidayAddApi(data).then((res) => {
              if (res.error_code === 0) {
                this.$message({
                  type: "success",
                  message: "添加成功",
                });
                this.dialogVisible = false;
                this.getList({
                  page: 1,
                  page_size: this.pageSize,
                });
              }
            });
          } else if (this.dialogTitle === "编辑假期") {
            if (this.dialogForm.class_type === 1) {
              // 处理编辑的时候不重新选班级
              if (this.dialogForm.class_ids?.length > 0) {
                data.class_ids = this.dialogForm.class_ids;
              } else if (this.dialogForm.class_list?.length > 0) {
                data.class_ids = this.dialogForm.class_list.map((item) => {
                  return item.class_id;
                });
              }
            } else {
              data.class_ids = [];
            }
            if (this.dialogForm.holiday_id) {
              data.holiday_id = this.dialogForm.holiday_id;
            }
            holidayEditApi(data).then((res) => {
              if (res.error_code === 0) {
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
                this.dialogVisible = false;
                this.getList({
                  page: this.page,
                  page_size: this.pageSize,
                });
              }
            });
          }
        }
      });
    },
    handleSortChange(data) {
      this.dialogForm.sort_field = data.prop;
      if (data.order == "descending") {
        this.dialogForm.sort_type = "desc";
      } else if (data.order == "ascending") {
        this.dialogForm.sort_type = "asc";
      } else {
        this.dialogForm.sort_type = "";
      }
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    getList(val) {
      const params = {
        page: val.page,
        page_size: val.page_size,
      };
      if (this.dialogForm.sort_field) {
        params.sort_field = this.dialogForm.sort_field;
      }
      if (this.dialogForm.sort_type) {
        params.sort_type = this.dialogForm.sort_type;
      }
      holidayListApi(params).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((it) => {
            it.start_time = dateFormat(
              "YYYY-mm-dd",
              Number(it.start_time) * 1000
            );
            it.end_time = dateFormat("YYYY-mm-dd", Number(it.end_time) * 1000);
            it.create_time = dateFormat(
              "YYYY-mm-dd",
              Number(it.create_time) * 1000
            );
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    addOrEmit(type, info) {
      if (type === "add") {
        this.dialogTitle = "添加假期";
        this.dialogVisible = true;
      } else if (type === "emit") {
        this.dialogTitle = "编辑假期";
        holidayDetailApi({
          holiday_id: info.holiday_id,
        }).then((res) => {
          if (res.error_code === 0) {
            this.dialogForm.vacationName = res.data.title;
            this.dialogForm.start_time = res.data.start_time * 1000;
            this.dialogForm.end_time = res.data.end_time * 1000;
            this.dialogForm.class_type = res.data.stop_type;
            this.dialogForm.class_list = res.data.class_list;
            this.dialogForm.remake = res.data.remark;
            this.dialogForm.holiday_id = res.data.holiday_id;
            this.dialogVisible = true;
          }
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.container-wrap {
  padding: 12px;
  .top-tips {
    height: 28px;
    line-height: 28px;
    background: #fff7e9;
    border-radius: 4px;
    font-size: 12px;
    color: #5c5d5e;
    padding: 0 6px;
    display: flex;
    width: 358px;
    margin: 15px 0;
    align-items: center;
    .question {
      width: 15px;
      height: 15px;
      opacity: 1;
      background: #bebfc0;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 16px;
      font-size: 10px;
      margin-left: 5px;
    }
  }
}
.footer {
  padding: 22px 18px;
  position: absolute;
  bottom: 0;
  right: 20px;
  .btns {
    text-align: right;
    .mwow-button-filled {
      margin-left: 10px;
    }
  }
}
/deep/ .el-form {
  .el-form-item__label {
    width: 85px !important;
  }
  .el-form-item__content {
    margin-left: 85px !important;
  }
  .el-date-editor {
    width: 100% !important;
  }
}
</style>
